module.exports = __webpack_public_path__ + "img/百康源网站-首页2.f0bbb737.png";